module.exports = __webpack_public_path__ + "img/symbol_14.8c262d73.png";